import { Injectable, Injector } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { HttpDataService } from './http-data.service';
import { ProfileService } from './profile.service';
import { ImageConversionService } from 'core/services/image-conversion.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsManagerService extends HttpDataService {
  bannerImg: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(protected injector: Injector, private profileService: ProfileService) {
    super(injector, '/resources/documents');
  }

  async uploadDocument(imageData: any, compress?: { quality: number; width?: number; height?: number }) {
    let clientId = this.profileService.getLoggedUser().clientId;
    const loggedUser = this.profileService.getLoggedUser();

    if (!clientId && loggedUser.roleOptions.scope === 'global') {
      clientId = environment.CLIENT;
    }

    if (compress) {
      imageData = await ImageConversionService.compressFileImage(imageData, compress);
    }

    const formData = new FormData();
    formData.append('clientId', clientId);
    formData.append('isInternalUrl', 'true');
    formData.append('type', imageData.type);
    formData.append('name', imageData.name.replace(/\s/g, ''));
    formData.append('files', imageData);

    const { document } = await lastValueFrom(this.createDocument(formData));

    return document.id;
  }

  createDocument(documentData: Object): Observable<any> {
    return this.http.post(this.baseUrl, documentData);
  }

  uploadS3File(s3Url, file): Observable<any> {
    return this.http.put(s3Url, file);
  }
}
